import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { decodeStr } from "../../../utils";

const CompanyMiniMap = ({ coords, companyName }) => {
  if (!coords || coords.length === 0) return null;

  // Calculate bounds to auto-fit all markers
  const lats = coords.map((c) => c.position[0]);
  const lngs = coords.map((c) => c.position[1]);
  const center = [
    lats.reduce((a, b) => a + b, 0) / lats.length,
    lngs.reduce((a, b) => a + b, 0) / lngs.length,
  ];

  // If only one marker, use fixed zoom; otherwise fit bounds
  const zoom = coords.length === 1 ? 13 : 10;

  return (
    <div className="company-mini-map">
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: 200, width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        {coords.map((coord) => (
          <Marker key={coord.officeId} position={coord.position}>
            <Popup>
              <div>
                <strong>{decodeStr(companyName || "")}</strong>
                <br />
                {coord.city}
                {coord.province && `, ${coord.province}`}
                <br />
                {coord.address}
                {coord.cap && ` - ${coord.cap}`}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default CompanyMiniMap;
